import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../common/components/AssetCreationWarning";
import { useOnPremAssetDetails } from "../../../common/hooks/useOnPremAssetDetails";
import { resolveOnPremAssetHref } from "../../../common/resolveOnPremAssetHref";
import { isOnPremAssetDeprecated } from "../../../OnPremAssetDetails";
import { OnPremVideoAssetSubtitleForm } from "./OnPremVideoAssetSubtitleForm";

export interface EditOnPremVideoAssetSubtitleAsideProps {
    isLabeled?: boolean;
    subtitleId: string;
}

export const EditOnPremVideoAssetSubtitleAside = (props: EditOnPremVideoAssetSubtitleAsideProps): JSX.Element => {
    const { isLabeled, subtitleId } = props;

    const { data: assetDetails, isLoading } = useOnPremAssetDetails();

    const { isOpen, onOpen, onClose } = useDisclosure();

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveOnPremAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    const areActionsDisabled = assetDetails && (isOnPremAssetDeprecated(assetDetails) || isLoading);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-video-subtitle"
            />
            <Aside type="form" headerText="Edit subtitle" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <OnPremVideoAssetSubtitleForm onDismiss={onClose} onSubmit={onSubmit} subtitleId={subtitleId} />
            </Aside>
        </AuthorizationWrapper>
    );
};
